// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("public/img/ok.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-error-summary, .box-body-error-summary {
  flex-direction: column;
  flex: 1;
  display: flex;
}

.snapshots-errors-summary__no-error {
  text-align: center;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.snapshots-errors-summary__no-error-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  flex: 1;
  min-height: 100px;
  max-height: 120px;
}

.snapshots-errors-summary__table {
  width: 100%;
}

.snapshots-errors-summary__row {
  cursor: pointer;
}

.snapshots-errors-summary__row:hover {
  background-color: #f5f5f5 !important;
}

.snapshots-errors-summary__cell {
  padding-left: 8px;
  padding-right: 8px;
}

.snapshots-errors-summary__cell--last {
  text-align: right;
  padding-top: 5px;
  padding-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/SnapshotManagement/Tabs/styles/ErrorSummary.css","webpack://./services/frontend/app/pages/SnapshotManagement/Tabs/styles/ErrorSummary.css"],"names":[],"mappings":"AAAA;ECCE,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,yDAA0C;EAC1C,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,OAAO;EACP,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* .discovery-start { */\n.box-error-summary {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.box-body-error-summary {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.snapshots-errors-summary__no-error {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: center;\n  left: 50%;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.snapshots-errors-summary__no-error-image {\n  background-image: url('public/img/ok.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  flex: 1;\n  min-height: 100px;\n  max-height: 120px;\n}\n.snapshots-errors-summary__table {\n  width: 100%;\n}\n.snapshots-errors-summary__row {\n  cursor: pointer;\n}\n.snapshots-errors-summary__row:hover {\n    background-color: #f5f5f5 !important;\n  }\n.snapshots-errors-summary__cell {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.snapshots-errors-summary__cell--first {\n    /* white-space: nowrap; */\n    /* width: 1%; */\n  }\n.snapshots-errors-summary__cell--last {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    text-align: right;\n  }\n/* } */\n",".box-error-summary, .box-body-error-summary {\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n}\n\n.snapshots-errors-summary__no-error {\n  text-align: center;\n  flex-direction: column;\n  flex: 1;\n  justify-content: center;\n  display: flex;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.snapshots-errors-summary__no-error-image {\n  background-image: url(\"public/img/ok.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  flex: 1;\n  min-height: 100px;\n  max-height: 120px;\n}\n\n.snapshots-errors-summary__table {\n  width: 100%;\n}\n\n.snapshots-errors-summary__row {\n  cursor: pointer;\n}\n\n.snapshots-errors-summary__row:hover {\n  background-color: #f5f5f5 !important;\n}\n\n.snapshots-errors-summary__cell {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.snapshots-errors-summary__cell--last {\n  text-align: right;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
